import React, { Component } from "react";
import DataTable from "react-data-table-component";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faCheck} from "@fortawesome/free-solid-svg-icons";
export default class ConfirmarOperacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mensajeModal: "",
    };
  }
  componentDidMount() {}
  handleClickConfirmar = () => {
    
    this.props.confirmarBtn();
    this.modalControl.click();
  };
  handleClickRechazar = () => {
    this.modalControl.click();
  };  

  render() {
    const columns = [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valors,
      },
    ];
    return (
      <div className="modal fade" id={this.props.idModal}>
        <div className="modal-dialog  modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-check" aria-hidden="true" />{" "}
                {this.props.title}
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <div className="row">
                  <div className="col-12">
                    <div>
                      <section className="content">
                        <div className="container-fluid">                           
                              <div className="row invoice-info">
                                <div className="col-12">
                                  <DataTable
                                    columns={columns}
                                    data={this.props.items}
                                    noHeader={true}
                                    customStyles={{rows: {style: {minHeight: '30px'}}}}
                                    getTheadGroupProps ={() => { return { style: { display: "none" } }; }}
                                    noTableHead={true}
                                  />
                                </div>
                              </div>
                              <hr/>
                              <div className="row invoice-info">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <p>
                                        Esta seguro que desea CONFIRMAR la
                                        operación?
                                      </p>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                      <button onClick={this.handleClickConfirmar}
                                        type="button"className="btn btn-cu-primary btn-consulta">
                                        <FontAwesomeIcon icon={faCheck} /> Confirmar
                                      </button>
                                                                   
                                      
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                    <button onClick={this.handleClickRechazar}
                                        type="button" className="btn btn-cu-quintary">
                                        <FontAwesomeIcon icon={faClose} /> Rechazar
                                      </button>        
                                    <button ref={(a) => (this.modalControl = a)}
                                        hidden type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">
                                          CERRAR
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
      </div>
    );
  }
}
